module.exports = __webpack_public_path__ + "img/edit.4fc7b755.svg";